import React, { Component } from 'react'
import { Header } from 'semantic-ui-react'

export default class Four0Four extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <>
                <Header as={'h1'}>Page not found</Header>
                <p>The requested page could not be found.</p>
            </>
        );
    }
}